jQuery(document).ready(function ($) {
  
// Add hidden class to all headings and paragraphs initially


// Function to check if element is in viewport with offset
function isElementInViewport(el, offset = 150) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return rect.top <= (windowHeight + offset);
}

// Function to handle scroll animation
function handleScrollAnimation() {
  $('.animate-element').each(function() {
    if (isElementInViewport(this)) {
      $(this).addClass('start-animation');
    }
  });
}

// Bind scroll event with throttling for better performance
let scrollTimeout;
$(window).on('scroll', function() {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function() {
      handleScrollAnimation();
      scrollTimeout = null;
    }, 50);
  }
});

// Handle elements on initial load
$(document).ready(function() {
  // Slight delay on page load for smoother initialization
  setTimeout(handleScrollAnimation, 100);
});

// Handle elements on dynamic content changes
$(document).on('contentChanged', handleScrollAnimation);
});